// Trash can menu icon (snippets/tf-menu-can.liquid). Dawn's menu drawer only flags "open" with the
// menu-opening class, so mirror it as data-state: "open" (the kick), "closing" (the fall and the "How the F is that a
// menu?" gag) or "tip" (the can just tips back onto its side). The fall plays the first time the menu closes in a
// visit, and again after a refresh; every other close is the tip.
if (!customElements.get('tf-menu-can')) {
  // "menu :)" points at the can (assets/tf-icons.css) until the menu's been opened in this visit.
  const HINT_KEY = 'tf-menu-known';
  let menuKnown = false;
  try {
    menuKnown = sessionStorage.getItem(HINT_KEY) === '1';
  } catch (error) {
    // No session storage: the pointer shows until the menu's opened on this page.
  }
  if (!menuKnown) document.documentElement.classList.add('tf-menu-hint');

  const GAG_KEY = 'tf-menu-gag';
  let gagPlayed = false;
  try {
    const nav = performance.getEntriesByType('navigation')[0];
    if (nav && nav.type === 'reload') sessionStorage.removeItem(GAG_KEY);
    gagPlayed = sessionStorage.getItem(GAG_KEY) === '1';
  } catch (error) {
    // No session storage (private browsing on old Safari): the fall plays once per page instead.
  }

  const closingState = () => {
    if (gagPlayed) return 'tip';
    gagPlayed = true;
    try {
      sessionStorage.setItem(GAG_KEY, '1');
    } catch (error) {
      // See above.
    }
    return 'closing';
  };

  customElements.define(
    'tf-menu-can',
    class TFMenuCan extends HTMLElement {
      connectedCallback() {
        this.details = this.closest('details');
        if (!this.details) return;
        this.open = this.details.classList.contains('menu-opening');
        if (this.open) this.dataset.state = 'open';
        this.observer = new MutationObserver(() => this.sync());
        this.observer.observe(this.details, { attributes: true, attributeFilter: ['class'] });
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      sync() {
        const open = this.details.classList.contains('menu-opening');
        if (open === this.open) return;
        this.open = open;
        this.dataset.state = open ? 'open' : closingState();
        if (open && !menuKnown) {
          menuKnown = true;
          try {
            sessionStorage.setItem(HINT_KEY, '1');
          } catch (error) {
            // See above.
          }
        }
      }
    }
  );
}

// Focus outline only for keyboard users: mouse clicks and taps set .tf-pointer on <html> (assets/tf-icons.css hides the
// outline), the Tab or arrow keys clear it. Starts in pointer mode, since most visitors never touch the keyboard.
(() => {
  const root = document.documentElement;
  root.classList.add('tf-pointer');
  document.addEventListener('pointerdown', () => root.classList.add('tf-pointer'), true);
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Tab' || event.key.startsWith('Arrow')) root.classList.remove('tf-pointer');
  }, true);
})();
